import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { InnModalPopup } from "../innModalPopup";
import backArrowIcon from "../../assets/images/top-back-arrow.svg";
import calenderIcon from "../../assets/images/top-calender-icon.svg";
import buldingIcon from "../../assets/images/top-building-icon.svg";
import docFront from "../../assets/images/adhar-card-front.png";
import docBack from "../../assets/images/adhar-card-back.png";
import { useDispatch, useSelector } from "react-redux";
import { propertyDetails, reservationData, setHomeNavigate } from "../../reducer/selfCheckinSlice";
import moment from "moment";
import { InnLoader } from "../innLoader";

function PreviewExample() {

    const [showCalenderData, setShowCalenderData] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const guestDetailObj = useSelector(reservationData);
    const propertyDetailObj = useSelector(propertyDetails);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const wait = timeOut => {
        return new Promise(resolve => setTimeout(resolve, timeOut));
    }

    useEffect(() => {
        setIsActive(true);
        if (propertyDetailObj === undefined) {
            navigate("/Unauthorised")
        }
        wait(1000).then(() => setIsActive(false))
    }, [])
    return (
        <div>
            <InnLoader className={isActive ? "active" : null}></InnLoader>
            <div className="wrapper">
                <div className="top-blue-bg">
                    <Link to="/Registration">
                        <div className="top-back-arrow">
                            <img src={backArrowIcon} />
                        </div>
                    </Link>
                    <div className="top-blue-hdng">
                        <h2 >Front Side</h2>
                    </div>
                    <div className="top-blue-bg-icon">
                        <div>
                            <img
                                onClick={() => setShowCalenderData(!showCalenderData)}
                                src={calenderIcon}
                            />
                        </div>

                        <Link to="/HomeInfo">
                            <div style={{ marginLeft: 10 }}>
                                <img src={buldingIcon} onClick={() => { dispatch(setHomeNavigate("FromPreviewExamplePage")) }}/>
                            </div>
                        </Link>
                    </div>
                </div>
                <div style={{ display: 'inline-block', width: '100%', height: 50 }}></div>
                <div className="upload-top">
                    <h3>Front Side</h3>
                    <ul>
                        <li>Photo of face should be on the front side of your ID</li>
                        <li>Please ensure the uploaded image is legible</li>
                    </ul>
                </div>
                <div className="adhar-img"><img
                    src={docFront} /></div>
                <div className="bdr-btm m-tp50"></div>
                <div className="upload-top m-tp20">
                    <h3>Back Side</h3>
                    <ul>
                        <li>Photo of face should be on the front side of your ID</li>
                        <li>Please ensure the uploaded image is legible</li>
                    </ul>
                </div>
                <div className="adhar-img"><img
                    src={docBack} /></div>
            </div>

            <div className="overlay">
                <div className="overlay-background"></div>
                {/* <div className="overlay-content"><span
                    className="spinner"></span>&nbsp;&nbsp;&nbsp;Loading
                </div> */}
            </div>
            <div className="hidden">
                <div className="loader-overlay"></div>
            </div>

            {showCalenderData ? (
                <InnModalPopup Onclose={() => setShowCalenderData(false)}>
                    <div class="modal-content x-small-popup">
                        <div
                            id="myModal3"
                            tabindex="-1"
                            role="dialog"
                            aria-labelledby="myModalLabel3"
                            class="model-popup"
                        >
                            <div role="document">
                                <div class="reg-detail text-left">
                                    <h2>{guestDetailObj?.GuestName}</h2>
                                </div>
                                <div class="reg-detail p-btm30">
                                    <div class="wdth50 bdr-rgt">
                                        <p>{moment(new Date(guestDetailObj?.Arrival_Date)).format("DD MMM")} - {moment(new Date(guestDetailObj?.Departure_Date)).format("DD MMM")}</p>
                                        <p>{guestDetailObj?.No_Of_Nights} Nights</p>
                                    </div>
                                    <div class="wdth50">
                                        <p class="text-right">Booking No: {guestDetailObj?.Booking_No}</p>
                                        <p class="text-right">{guestDetailObj?.No_Of_Rooms} Room {guestDetailObj?.Adult} Adults</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </InnModalPopup>
            ) : null}

        </div>
    )
}

export default PreviewExample